module.exports = __webpack_public_path__ + "img/icon-house.fb577a98.svg";